import SignupUserView from "./SignupUserView";

export const SignupUserContainer = () => {
  return (
    <div>
      <SignupUserView />
    </div>
  );
};
